import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Trans } from 'react-i18next';
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import CollapsibleContainer from '../../components/CollapsibleContainer';
import UpperContainer from '../../components/UpperContainer';
import ButtonContainer from '../../components/ButtonContainer';
import {
  animateToScreen as animateToScreenAction,
  animateToScreenAndBeep as animateToScreenAndBeepAction,
} from '../../redux/ui/actions';
import addPassengersImg from '../../assets/images/btn-add-passengers-small.png';
import TextColumnContent from '../../molecules/TextColumnContent';
import BackButtonContainer from '../../molecules/BackButtonContainer';
import Button from '../../components/Button';
import Description from '../../components/Description';
import { H2, Text } from '../../components/Typography';
import { MOBILE_BREAKPOINT_IN_PX } from '../../constants';

const AddPassengersImage = styled.img`
  width: 36px;
  height: 20px;
  position: relative;
  top: 4px;
  margin-right: 4px;

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    width: auto;
    top: 1.5px;
  }
`;

class ValueTicketPurchaseTexts extends PureComponent {
  // eslint-disable-next-line
  state = { showCardButtonDisabled: false };

  goToConfirmationScreen = () => {
    this.setState({ showCardButtonDisabled: true }, () => {
      this.props.animateToScreenAndBeep('ValueTicketConfirmation');
    });
  };

  render() {
    const { showCardButtonDisabled } = this.state;
    const { animateToScreen, t } = this.props;
    return (
      <>
        <BackButtonContainer
          home={t('Generic.breadcrumbHome')}
          homeLink={t('Generic.breadcrumbHomeLink')}
          secondaryHome={t('Generic.breadcrumbSecondaryHome')}
          secondaryHomeLink={t('Generic.breadcrumbSecondaryHomeLink')}
          textPrev={t('Flows.home')}
          text={t('Flows.valueTicket')}
          onClick={() => animateToScreen('Home')}
        />
        <TextColumnContent paddingTop={-100} hasBackButton>
          <H2>
            <Trans i18nKey="ValueTicketPurchase.title" />
          </H2>
          <UpperContainer>
            <Description>
              <Text>
                <Trans i18nKey="ValueTicketPurchase.description" />{' '}
                <AddPassengersImage src={addPassengersImg} />
                <Trans i18nKey="ValueTicketPurchase.descriptionSuffix" />
              </Text>
            </Description>
            <Button
              onClick={this.goToConfirmationScreen}
              text={t('Generic.showCard')}
              disabled={showCardButtonDisabled}
            />
          </UpperContainer>
          <CollapsibleContainer>
            <ButtonContainer>
              <Button
                onClick={this.goToConfirmationScreen}
                text={t('Generic.showCard')}
                disabled={showCardButtonDisabled}
              />
            </ButtonContainer>
            <Collapsible
              trigger={t('Generic.additionalInfo')}
              transitionTime={300}
            >
              <Description>
                <Text>
                  <Trans i18nKey="ValueTicketPurchase.description" />{' '}
                  <AddPassengersImage src={addPassengersImg} />
                  <Trans i18nKey="ValueTicketPurchase.descriptionSuffix" />
                </Text>
              </Description>
            </Collapsible>
          </CollapsibleContainer>
        </TextColumnContent>
      </>
    );
  }
}

ValueTicketPurchaseTexts.propTypes = {
  animateToScreen: PropTypes.func.isRequired,
  animateToScreenAndBeep: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  animateToScreen: (screenName) => dispatch(animateToScreenAction(screenName)),
  animateToScreenAndBeep: (screenName) => dispatch(animateToScreenAndBeepAction(screenName)), // eslint-disable-line
});

// prettier-ignore
export default connect(null, mapDispatchToProps)(ValueTicketPurchaseTexts);
